export default {
  props: {
    text: {
      type: String,
      default: '打开APP，查看更多内容'
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    styles() {
      if (this.isApple || !this.isApp) {
        return {};
      }
      const statusBarHeight = window.cfmoto.statusBarHeight();
      return {
        paddingBottom: `${statusBarHeight}px`
      };
    }
  },
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};